import { render, staticRenderFns } from "./FontAwesomeIcon.vue?vue&type=template&id=52ce3ed8&scoped=true&"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce3ed8",
  null
  
)

export default component.exports